import { useEffect, useState } from "react";
import { ArrowLeft } from "lucide-react";
import { DataTable } from "../components/DataTable";
import { bookingService } from "../services/bookingService";
import { today, addDays } from "../utils/date";
import { statusColor } from "../utils/statusColors";

const TYPES = {
  arrivals: {
    title: "Today's Arrivals",
    fields: ["guestName", "roomName", "checkInDate", "contact", "status", "totalAmount"],
    currencyFields: ["totalAmount"],
  },
  departures: {
    title: "Today's Departures",
    fields: ["guestName", "roomName", "checkOutDate", "contact", "status", "totalAmount"],
    currencyFields: ["totalAmount"],
  },
  available: {
    title: "Available Room's",
    fields: ["roomName", "roomType", "bedType", "price", "maxOccupancy", "status"],
    currencyFields: ["price"],
  },
};

export function GuestDetails({ type = "arrivals", date, onBack, notify }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const config = TYPES[type] || TYPES.arrivals;

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    (async () => {
      try {
        const t = date || today();
        let result = [];
        if (type === "arrivals") {
          const all = await bookingService.getReport({ start: t, end: t, roomId: "" });
          result = all.filter((b) => b.checkInDate === t);
        } else if (type === "departures") {
          result = await bookingService.getReport({ start: t, end: t, roomId: "" });
          result = result.filter((b) => b.checkOutDate === t);
        } else if (type === "available") {
          result = await bookingService.getAvailability(t, addDays(t, 1));
          result = result.filter((r) => r.status === "Available");
        }
        if (!cancelled) setRows(result);
      } catch (err) {
        if (!cancelled) {
          setRows([]);
          notify?.(err?.message || `Could not load ${config.title.toLowerCase()}.`);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [type, date]);

  return (
    <section className="stack" aria-busy={loading || undefined}>
      <div className="toolbar">
        <button className="secondary" onClick={onBack}><ArrowLeft size={16} />Back to Dashboard</button>
      </div>
      <DataTable
        rows={rows}
        loading={loading}
        header={config.title}
        emptyMessage={`No records for ${config.title.replace(/^Today's /, "").toLowerCase()}.`}
        fields={config.fields}
        currencyFields={config.currencyFields}
        statusColors={{ status: statusColor }}
      />
    </section>
  );
}
